import React, { useMemo } from 'react';
import BasicCheckbox from 'components/BasicCheckbox';
import PropTypes from 'prop-types';
import TooltipIcon from 'components/TooltipIcon';

const QuickFilterCheckbox = props => {
  const labelStyles = useMemo(() => {
    return (
      props.labelStyles || {
        fontFamily: 'Noto Sans, sans-serif',
      }
    );
  }, [props.labelStyles]);

  const label = useMemo(() => {
    return (
      <span style={{ display: 'flex' }}>
        {props.title}
        <TooltipIcon content={props.tooltipText} type="question" />
      </span>
    );
  }, [props.title, props.tooltipText]);

  return (
    <div>
      <BasicCheckbox
        value={props.value || ''}
        singleRow
        checked={props.checked}
        name={props.name}
        onChange={props.onChangeHandler}
        labelStyles={labelStyles}
        renderLabel={label}
      />
    </div>
  );
};

QuickFilterCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  title: PropTypes.string.isRequired,
  tooltipText: PropTypes.string.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
  value: PropTypes.string,
  labelStyles: PropTypes.object,
};
export default QuickFilterCheckbox;
